import { RouterModule } from '@angular/router';
import { NgModule, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { UserComponent } from 'app/layout/common/user/user.component';
import { SharedModule } from 'app/shared/shared.module';
import { CertificateComponent } from './certificate/certificate.component';

const routing = [ ];

@NgModule({
    declarations: [
        UserComponent,
        CertificateComponent
    ],
    imports     : [
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        SharedModule,
        RouterModule.forChild(routing),
    ],
    exports     : [
        UserComponent
    ]
})
export class UserModule
{
}
